/**
 * 테넌트 설정 (프론트엔드 기본값)
 * 백엔드 응답으로 오버라이드 가능
 * 
 * 색상 테마 설정:
 * - colorTheme.primaryHue: Primary 색상의 Hue 값 (0-360)
 *   * dhsteel: 206.382 (파란색 계열 - 원본 색상)
 *   * oksteel: 185 (틸/청록 계열)
 * - 새로운 테넌트 추가 시: 다른 테넌트와 구분되는 Hue 값 선택 (최소 20도 이상 차이 권장)
 */
export const TENANT_CONFIG = {
  micromos: {
    companyName: '(주)마이크로모스',
    logoPath: './images/micromos.png',
    // micromos는 현재 사용하지 않으므로 기본값 사용
    colorTheme: {
      primaryHue: 206.382, // dhsteel과 동일
    },
  },
  dhsteel: {
    companyName: '대한철강(주)',
    logoPath: './images/micromos.png',
    // 원본 파란색 계열
    colorTheme: {
      primaryHue: 206.382,
    },
  },
  oksteel: {
    companyName: '오케이스틸(주)',
    logoPath: './images/micromos.png',
    // 틸 - 청록 계열 (Hue: 185)
    // 주황 - 코랄 계열 (Hue: 40)
    // 인디고 - 보라 계열 (Hue: 275)
    colorTheme: {
      primaryHue: 40,
    },
  },
};

/**
 * 현재 도메인에서 테넌트 키 추출
 */
export const getTenantFromDomain = () => {
  const host = window.location.hostname;
  const parts = host.split('.');
  
  // 서브도메인이 있는 경우 (A.example.com)
  if (parts.length >= 3) {
    return parts[0].toLowerCase();
  }
  
  // 기본값: micromos (문제 발생 위치 확인용)
  return 'dhsteel';
};

/**
 * 현재 테넌트 정보 가져오기 (기본값)
 * 백엔드 응답으로 오버라이드됨
 */
export const getCurrentTenant = () => {
  const tenantKey = getTenantFromDomain();
  return TENANT_CONFIG[tenantKey] || TENANT_CONFIG.dhsteel;
};

